export class CommonConstants {
  public static DEFAULT_EMPTY_STRING = '';
  public static ONLY_ALPHABETS_PATTERN_STRING: any = /^([a-zA-Z])$/;
  public static URL_SEPARATOR = '/';
  public static PIPE_SEPARATOR = '|';
  public static QUERY_PARAMETER_LITERAL = '?';
  public static DISCLAIMER_TEXT = 'Issuance of policy is subject to successful validation of your KYC details.';
  public static NO_PLANS_AVAILABLE_TEXT = "No plans available for current plan selection";
  public static EQUALS = '=';
  public static AMPERSAND = '&';
  public static PERCENTAGE_LITERAL = '%';
  public static EMAIL_PATTERN_STRING = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
  // timer value in seconds
  public static SESSIONEXPIRYTIMER = 30;
  // timeout value in minutes
  public static appIdleTimeout: number = 30;
  // Cookie Keys
  public static CookieKeys = {
    AuthId: 'authId',
    NTID: 'NTID',
    AuthType: 'authType',
    State: 'state',
    Code: 'code',
    AuthToken: 'authToken',
    ProcessInstanceDetails: 'processInstanceDetails',
    LoanApplicationId: 'loanApplicationId',
    LoanApplicationKey: 'loanApplicationKey',
    Error: 'error',
    UserName: 'uDetails',
    DeviceDetails: 'DeviceDetails',
    ClientId: 'SC_ID',
    SecretKey: 'SS_ID',
    UserAuthenticationToken: 'UserAuthenticationToken',
    GeoLocationDetails: 'GeoLocationDetails',
    PSVToken: 'Customer_SS_1',
    JWToken: 'SS_1',
    GuardToken: 'SS_2',
    GuardKey: 'SS_4',
    EmployeeResume: 'SS_R_TYP',
    EmployeeResume_Value: 'emp',
    IsLaIsPh: 'IsLaIsPh',
    MobileState: 'mobileState',
    PaymentSuccess: 'paymentSuccess',
    JourneyType: 'journeytype',
    PaymentRedirect: 'paymentRedirect',
    InsProductType: 'insProductType',
    processId: 'processId',
    applicationId: 'applicationId',
    PrevPolicyDetId: 'prevPolicyDetId',
    PlanQuoteIds: 'planQuoteIds',
    QuoteCriteriaId: 'appQuoteCriteriaId',
    BuynowNextTaskKey: 'nextTaskKey',
    BuyNowQuoteId: 'quoteId',
    RetryStatusCall: 'retryStatusCall',
    principalId: 'principalId',
    Email: 'uEmail',
    pinCode: 'uPinCode',
    editPolicyDetails: 'editPolicyDet',
    selectedQuoteId: 'selectedQuoteId',
    JWTokenEP: 'EP_SS_1',
    GuardTokenEP: 'EP_SS_2',
    GuardKeyEP: 'EP_SS_4',
    isPaymentPage: 'isPayment',
    isRenewalPage: 'isRenewal',
    orderId: 'orderId',
    planQuoteCriteriaData: 'planQuoteCriteriaData',
    NextTaskKeyOmHR: 'NextTaskKeyOmHR',
    IsplansRefine: 'IsplansRefine',
    Source: 'source',
    latitude: 'latitude',
    longitude: 'longitude',
    platform: 'platform',
    sessionId: "X-Session-Token",
    lastErrorRoute: 'lastErrorRoute',
    epTokenDetails: 'EP_TK',
    epUserDetails: 'EP_UD',
    backFlow: 'backFlow',
    sdkVersion: 'sdk_version',
    useResp: 'useResp',
    CKYC_Customer_SS_1: 'CKYC_Customer_SS_1',
    updatedPremium: 'updatedPremium',
    userMob: 'userMob',
    userDob: 'userDob',
    authtoken: 'authtoken',
    loginSessionId: 'loginSessionId',
    vehicleType : 'vehicleType',
    vehicleRegistrationNumber: 'vehicleRegistrationNumber',
    mobileNumber:'mobileNumber',
    vehicleMake:'vehicleMake',
    isClaim: 'IsClaim',
    pin_code: 'pin_code',
    mobile_number: 'mobile_number',
    customerToken: 'customerToken',
    ssoEnabled: 'ssoEnabled',
    autoLease: 'autoLease',
    product: 'product',
    sessionIdAutolease: 'sessionIdAutolease',
    vehicleDetails : 'vehicleDetails',
    registrationYear:'registrationYear',
    manufacturingYear:'manufacturingYear',
    rtoCode:'rtoCode',
    backAutoLease : 'backAutoLease',
    corporateFlag : 'corporateFlag',
    sfdcUCF : 'sfdcUCF',
    autoleaseUtmSource : 'autoleaseUtmSource',
    productIdetifier:'productIdetifier',
    campaignCookie : 'campaignCookie',
    accessToken : 'accessToken',
    miniOrangeToken : 'miniOrangeToken'
  };
  public static LOAN_PRODUCT_CODES = {
    Secured_Personal_Loan: 'DHB',
    Secured_Loan: 'SSL',
    Travel_Insurance: 'TGI',
    Health_Insurance: 'HGI',
    Cyber_Insurance: 'CGI',
    Health_ExtraInsurance: 'HTP',
    Motor_Insurance: 'MGI'
    // li
  };
  public static LOAN_PRODUCT_CATEGORY_CODES = {
    Unsecured_Loan: 'UL',
    Secured_Loan: 'SL',
    Travel_Insurance: 'ins',
    Health_Insurance: 'ins',
    Cyber_Insurance: 'ins',
    Health_ExtraInsurance: 'HGI',
    Motor_Insurance: 'ins'
  };
  public static APPLICANT_PHONE_TYPES = {
    Mobile: 'MOBILE',
    Fax: 'FAX',
    General: 'GENERAL',
    HomeFax: 'HOMEFAX',
    HomePhone: 'HOMEPHN',
    Office: 'OFFICE',
    SmsMobile: 'SMSMOB',
    Work: 'WORK'
  };
  public static APPLICANT_EMAIL_TYPES = {
    CoApplicant_1: 'CO-BOR1',
    CoApplicant_2: 'CO-BOR2',
    Communication: 'COMM',
    Guardian: 'GUARDIAN',
    Husband: 'HUSBAND',
    Nominee: 'NOMINEE',
    Office: 'OFFICE',
    Other: 'OTHER',
    Parent: 'PARENT',
    Personal_1: 'PERSON1',
    Personal_2: 'PERSON2',
    Wife: 'WIFE',
    Work: 'WORK'
  };
  public static QueryParamsKeys = {
    EmailToConfirmType: 'type',
    EmailTokenToConfirm: 'id',
    PaymentStatus_QueryParams: 'queryParams',
    appUtmRefCode: 'appUtmRefCode',
    appUtmSource: 'appUtmSource',
    appUtmMedium: 'appUtmMedium',
    appUtmCampaign: 'appUtmCampaign',
    appUtmTerm: 'appUtmTerm',
    appUtmContent: 'appUtmContent',
    UTMData: 'UTMData',
    BFLBranch: 'BFLBranch',
    GCLID: 'gclid',
    Productcode: 'prdcode',
    Product: 'product',
    ApplicantId: 'apcantid',
    ApplicationId: 'aptionid',
    ApplicationApplicantId: 'apcaptid',
    InsuranceProductType: 'insuranceProductType',
    IsMobile: 'isMobile',
    VehicleRegistrationNumber: 'vehicleRegistrationNo',
    InsProductType: 'insProductType',
    mobileNumber: 'mobileNo',
    additionalParam: 'additionalParam',
    marketplace: 'marketplace',
    res: 'res',
    utmSource: 'utm_source'
  };
  public static SharedServiceDataKeys = {
    JourneySource: 'JourneySource',
    Applicant: 'Applicant',
    AadharNumber: 'AadharNumber',
    ProgressStateInfo: 'ProgressStateInfo',
    EsignDocmentList: 'esignDocmentList',
    IsNewApplication: 'IsNewApplication',
    ApplicationID: 'ApplicatonID'
  };
  // Routes
  public static Routes = {
    Home: '',
    MultitabFailed: 'multitabFailed',
    Application: {
      Home: 'applicationStage',
      EditDetails: 'editDetails',
      nomineeDetails: 'nomineeDetails',
      AddressDetails: 'addressNomineeDetails',
      PlanDetail: 'planDetail',
      RenewVerifyMobile: 'renewVerifyMobile',
      AdditionalDetails: 'additionalDetails',
      ProposerPersonalDetails: 'proposerPersonalDetails',
      VehicleRegistration: 'vehicleRegistration',
      VehicleDetails: 'vehicleDetails',
      AdditionalPolicyDetails: 'additionalPolicyDetails',
      OwnerDetails: 'ownerDetails',
      PaymentFailed: 'paymentFailed',
      Congratulations: 'congratulation',
      MotorDetails: 'motorDetails',
      Previouspolicydetail: 'previousPolicy',
      quoteConsentOtp: 'quoteConsentOtp',
      paymentInitiate: 'paymentInitiate',
    },
    OwnerDetails: {
      OwnerDetails: 'ownerDetails',
    },
    PlanListing: {
      PlanProductListing: 'planProductListing',
      BuyPolicyDetails: 'buyPolicyDetails',
    },
    Verification: {
      Home: 'verify',
      VerifyMobile: 'verifyMobile'
    },
    FinalModule: {
      Home: 'final',
      ProductReview: 'productReview',
      RejectApplication: 'rejectApplication',
      PaymentReview: 'paymentReview',
      Congratulations: 'Congratulations',
      PaymentFailed: 'PaymentFailed',
      PaymentStatus: 'paymentStatus',
      RetryPaymentPage: 'retryPaymentPage',
      Payment: 'payment',

    },
    Logout: 'logout',
    ResumeApplication: 'resumeApplication',
    CustomerLogin: 'customerLogin',
    CustomerLoginBase: 'customerLogin',
    Reject: 'reject',
    NonStp: 'nonStp',
    otp: 'otpverification',
    generalInsurance: 'general-insurance'
  };
  // input type
  public static InputTypes = {
    ReadOnly: 'ReadOnly',
    Selection: 'Selection',
    Dynamic: 'Dynamic',
    Button: 'Button',
    Date: 'Date',
    Boolean: 'Boolean',
    InputBox: 'InputBox',
    CheckBox: 'boolean'
  };
  // APIURL
  public static APIURL = {
    ABTESTLAYOUT: 'l1',
    getGeoLocationBasedOnPin: '{DOMAIN01}/v2/referencedata/locations/{0}',
    startApplicationActiviti: '{DOMAIN01}/v2/insurances/motor/workflow/process',
    completeActivitiTask: '{DOMAIN01}/v2/insurances/motor/workflow/process',
    getActivitiTaskDetails: '{DOMAIN01}/v2/insurances/motor/workflow/details',
    getSSOTokenForUser: '{DOMAIN01}/v3/logins/ui',
    getTokenForUser: '{DOMAIN01}/v2/logins/ui',
    getPaymentDetails: '{DOMAIN01}/v1/insurance/business/payments/pgateways/initiate',
    getMaritalStatusCodes: '{DOMAIN01}/v1/referencedata/maritalstatuscode',
    getCountry: '{DOMAIN01}/v1/referencedata/countries?countryName=',
    getRelationship: '{DOMAIN01}/v1/insurance/products/relationgroups/OMHLNOMINEEREL',
    getRepaymentPayload: '{DOMAIN01}/v1/nosqldata/audit?applicationId=',
    downloadPdf: '{DOMAIN01}/v1/documentmanagement/exportpdf',
    downloadReciept: '{DOMAIN01}/v1/insurances/motor/{applicationId}/payments/receipts',
    getNomineeRelationshipLookupService: '{DOMAIN01}/v1/referencedata/relationshiptypes?groupcode=HTPNOMREL',
    getPlanSumAssured: '{DOMAIN01}/v1/bre/insurances/motor/plans/sumassured',
    getPlanRiders: '{DOMAIN01}/v1/bre/insurances/motor/plans/riders',
    resumeSendOtp: '{DOMAIN01}/v1/logins/forms/mobile',
    resumeGetOtp: '{DOMAIN01}/v1/logins/forms/mobile/otp',
    getAllStatesApi: '{DOMAIN01}/v1/referencedata/allstates',
    getCitiesApi: '{DOMAIN01}/v1/referencedata/cities?stateKey=',
    getDocAndAppStatus: '{DOMAIN01}/v1/insurances/motor/{applicationId}/status',
    getPaymentStatus: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/payments/status',
    getPolicyStatus: '{DOMAIN01}/v1/insurance/principal/refreshpolicy/application/{applicationId}/quote/{quoteId}',
    getHealthRequestId: '{DOMAIN01}/v1/insurances/booking/initiation',
    validatePersonalEmailID: '{DOMAIN01}/v1/referencedata/checkdomain?email={0}',
    inquiries: '{DOMAIN01}/v2/insurances/motor/inquiries',
    rtos: '{DOMAIN01}/v1/insurance/product/smartsearch/motor/rtos',
    getVehicleList: '{DOMAIN01}/v1/insurance/product/smartsearch/motor/vehicles?vehicleModel=',
    getfinancerList: '{DOMAIN01}/v1/insurance/product/smartsearch/motor/financier',
    refinements: '{DOMAIN01}/v2/insurance/business/quote/refinement',
    insuranceproviders: '{DOMAIN01}/v1/insurance/products/providers/2',
    emicardeligibiltyservice: '{DOMAIN01}/v1/insurance/business/payments/emicards/eligibility',
    addWhatsappConsent: '{DOMAIN01}/v1/whatsapp/addconsent',
    getWhatsappConsent: '{DOMAIN01}/v1/whatsapp/getconsent',
    addPartnerConsent: '{DOMAIN01}/v1/whatsapp/partner/addconsent',
    postCall: '{DOMAIN01}/v1/insurance/business/applications',
    getCall: '{DOMAIN01}/v1/insurance/business/applications',
    postCallVehicleDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/vehicledetails',
    getCallVehicleDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/vehicledetails',
    postCallPreviousPolicy: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/prevpolicydetails',
    getPreviousPolicyDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/prevpolicydetails/{prevPolicyDetId}',
    getPollingQuotes: '{DOMAIN01}/v1/insurance/quote/{quoteId}',
    getPlanSummary: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/summary',
    postEditNcbDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/products/quotes',
    // postEditNcbDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/prevpolicydetails',
    getRiders: '{DOMAIN01}/v1/insurance/business/products/{productCategoryCode}/addons',
    prvPolicyLookup: '{DOMAIN01}/v1/insurance/products/lookupcodes/MOTOR_{type}_PREV_POLICY_TYPE',
    getCarOwnerDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/persons/1',
    postCarOwnerDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/persons/1',
    postAddressDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/addresses/1',
    GetAddressDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/addresses/1',
    getPolicyNumber: '{DOMAIN01}/v1/insurance/applications/{applicationId}/quotes/{quoteId}/policies',
    getPolicyDocument: '{DOMAIN01}/v1/insurance/policydoc/application/{applicationId}/quote/{quoteId}',
    emicardsTransactions: '{DOMAIN01}/v1/insurance/business/payments/emicards/transactions',
    postprocessingPayment: '{DOMAIN01}/v1/insurance/payments/pgateways/postprocessing',
    cancelPayment: '{DOMAIN01}/v1/insurance/payments/pgateways/cancel',
    CongratulationsData: '{DOMAIN01}/v1/insurance/policydoc/application/{applicationId}/quote/{quoteId}?quoteItemId={quoteItemId}',
    emiOPTPost: '{DOMAIN01}/v1/insurance/business/payments/emicards/otp',
    retryPayment: '{DOMAIN01}/v1/insurance/business/payments/retry',
    getPolicyDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/additionalmotor',
    ResumeLandingGetCall: '{DOMAIN01}/v1/insurance/business/session/{sessionId}/{prodCatCode}',
    ValidateOtp: '{DOMAIN01}/v1/otp/validate',
    ResumeAppListing: '{DOMAIN01}/v1/insurance/business/redirect',
    MotorTwoWheelerProductLaunch: '{DOMAIN02}/gi/motorInsurance/two-wheeler-insurance/premium-calculator/#/',
    MotorFourWheelerProductLaunch: '{DOMAIN02}/gi/motorInsurance/car-insurance/premium-calculator/#/',
    ApplicationListingGetCall: '{DOMAIN01}/v1/insurance/business/applications/search?mobileNo={mobileNo}&productCategory={productCategory}&additionalParam={additionalParam}',
    ResumeGetQuote: '{DOMAIN01}/v1/insurance/ep/applications/{applicationId}/quotes',
    downloadPlanBrochure: '{DOMAIN01}/v1/insurance/business/products/variants/{variantcode}/brochure',
    postRenewalBuyNow: '{DOMAIN01}/v1/insurance/business/renewal/redirect',
    networkGarage: '{DOMAIN01}/v1/insurance/product/smartsearch/motor/garages?cityKey={0}&productCode={1}&garageName={2}',
    networkGarageCount: '{DOMAIN01}/v1/reference/garages?pincodeKey={0}&productCode={1}',
    nomineeDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/nominees',
    orderIDGeneration: '{DOMAIN01}/v1/insurance/business/payments/pgateways/initiate',
    postPaymentStatus: '{DOMAIN01}/v1/insurance/business/payments/pgateways/postpayment',
    nomineesService: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/nominees',
    ValidatePostOtp: '{DOMAIN01}/v2/login/forms/mobile',
    postLeadType: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/leadtype/{leadType}',
    salutationDetails: '{DOMAIN01}/v1/insurance/business/principals/{principalKey}/master?apiName=Salutation',
    getPaymentStatusRoute: '{DOMAIN01}/v1/insurance/applications/{applicationId}/quotes/{quoteId}/summary?authtoken={authtoken}',
    sendEventStatus: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/payments/status',
    postOTPForReviewDetail: '{DOMAIN01}/v1/insurance/business/application/{applicationId}/quotes/{quoteId}/otpConsent',
    ValidatePostOtpForReviewDetails: '{DOMAIN01}/v1/insurance/business/application/{applicationId}/quotes/{quoteId}/otpConsent',
    resendOtpForReviewDetail: '{DOMAIN01}/v1/insurance/business/application/{applicationId}/quotes/{quoteKey}/consents/{consentkey}/otp',
    sessionExtendService: '{DOMAIN01}/v1/insurance/business/application/{applicationId}/session/put',
    sendQuotatioLinkService: '{DOMAIN01}/v1/insurance/employeeportal/appliation/notification',
    validateRegistrationNo: '{DOMAIN01}/v1/insurance/business/validateregistrationnumber/{registrationnumber}',
    masterLookupService: '{DOMAIN01}/v1/insurance/products/lookupcodes/{lookup_code}',
    postKycDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/persons/1',
    saveDocumentPostCall: '{DOMAIN01}/v2/insurance/business/quotes/{quoteId}/quoteitems/{quoteItemId}/documents?documentCategoryCode={documentCategoryCode}&documentTypeCode={documentTypeCode}',
    getDocumentTypes: '{DOMAIN01}/v1/insurance/business/documentTypes/application/{applicationId}/quotes/{quoteId}',
    postKycConsent: '{DOMAIN01}/v2/insurance/business/kyc/consent/applications/{applicationId}/quotes/{quoteId}/persons/{personCode}',
    getDocumentList: '{DOMAIN01}/v1/insurance/business/quotes/{quoteId}/quoteitems/{quoteItemId}/documents',
    getDocumentData: '{DOMAIN01}/v1/insurance/business/quotes/{quoteId}/quoteitems/{quoteItemId}/documents/{documentRefId}',
    removeDocument: '{DOMAIN01}/v1/insurance/business/quotes/{quoteId}/quoteitems/{quoteItemId}/documents/{documentRefId}',
    getRtoCodeDetails: '{DOMAIN01}/v1/insurance/product/smartsearch/motor/rto?rtoCode={rtoCode}&rtoName={rtoName}',
    postMoauthLogin : '{DOMAIN01}/v1/insurance/business/moauthlogin'
  };
  public static AEMURLs = {
    PlanListAem: '{AEMURL}/api/assets/bajajfinserv/insurance/motorinsuranceitems/motorinsurancelistingfragment.json',
    LandingpageAem: '{AEMURL}/api/assets/bajajfinserv/insurance/motorinsuranceitems/motorinsurancelandingpage.json',
    PlanListAembfl: '{AEMURL}/api/assets/insurance-marketplace/insurance-mall-dj/motorinsuranceitems/motorinsurancelistingfragment.model.json',
    LandingpageAembfl: '{AEMURL}/api/assets/insurance-marketplace/insurance-mall-dj/motorinsuranceitems/motorinsurancelandingpage.model.json',
    NewCarInsAemBfl: '{AEMURL}/content/dam/insurance-marketplace/insurance-mall-dj/motorinsuranceitems/autoleasenewcar.json'
  };
  public static CurrencyCoversionUnits = {
    Lacs: 100000,
    Crore: 10000000
  };
  public static SourceTypes = {
    System: 'system',
    Journey: 'journey',
    CustomerPortal: 'customerportal',
    EmployeePortal: 'employeeportal',
    Customer: 'CUSTOMER',
    Aadrila: 'AADRILA',
    InternalDedupe: 'Internal Dedupe',
    Signzy: 'Signzy'
  };
  public static footerText = [
    {
      title: 'Bajaj Finserv Direct Limited',
      desc: '4TH Floor, B2 Building, Cerebrum IT Park, Kumar City, Kalyani Nagar, Pune – 411014.'
    }
  ];
  public static EmitterEventTypes = {
    LoadingEvent: 'LoadingEvent',
    GlobalErrorEvent: 'GlobalErrorEvent',
    ProgressStateEvent: 'ProgressStateEvent',
    LoadingSmallLoaderEvent: 'SmallLoader',
    NavigationEvent: 'NavigationFlag',
    ProcessCallCompleteEvent: 'ProcessCallComplete',
    MobileAppCheck: 'MobileAppCheck',
    AadhaarOTPRequested: 'aadhaarOTPRequested',
    SessionExpired: 'SessionExpired'
  };
  public static errorCodes = [
    'OTP_801', 'OTP_802', 'OTP_803', 'OTP_804', 'OTP_805', 'OTP_806', 'OTP_807', 'OTP_808', 'OTP_809', 'OTP_810',
    'OTP_811', 'OTP_812', 'OTP_813', 'OTP_814', 'OTP_815', 'OTP_816', 'OTP_817', 'OTP_818', 'OTP_819', 'OTP_820'
  ];
  public static offerAdds = {
    // tslint:disable-next-line:max-line-length
    healthInsuranceAdd: 'https://www.bajajfinservmarkets.in/insurance/health-insurance/family-health-insurance.html?pid=Web-Platforms:SPA:2w-SPA-MultiTab:Family-Health-Insurance:Banner:CrossSell',
    // tslint:disable-next-line:max-line-length
    UlipInsuranceAdd: 'https://www.bajajfinservmarkets.in/insurance/ulip/investment-plans.html?pid=Web-Platforms:SPA:2w-SPA-MultiTab:ULIP-Insurance:Banner:CrossSell',
    UlipRejectInsuranceAdd: 'https://www.bajajfinservmarkets.in/insurance/ulip/investment-plans.html?pid=Web-Platforms:SPA:2w-SPA-Reject:ULIP-Insurance:Banner:CrossSell',
    healthRejectInsuranceAdd: 'https://www.bajajfinservmarkets.in/insurance/health-insurance/family-health-insurance.html?pid=Web-Platforms:SPA:2w-SPA-Reject:Family-Health-Insurance:Banner:CrossSell',
    travelInsuranceAdd: '',
    motorInsuranceAdd: '',
    cyberInsuranceAdd: '',
    healthInsuranceAdd4W: 'https://www.bajajfinservmarkets.in/insurance/health-insurance/family-health-insurance.html?pid=Web-Platforms:SPA:4w-SPA-MultiTab:Family-Health-Insurance:Banner:CrossSell',
    UlipInsuranceAdd4W: 'https://www.bajajfinservmarkets.in/insurance/ulip/investment-plans.html?pid=Web-Platforms:SPA:4w-SPA-MultiTab:ULIP-Insurance:Banner:CrossSell',
    UlipRejectInsuranceAdd4W: 'https://www.bajajfinservmarkets.in/insurance/ulip/investment-plans.html?pid=Web-Platforms:SPA:4w-SPA-Reject:ULIP-Insurance:Banner:CrossSell',
    healthRejectInsuranceAdd4W: 'https://www.bajajfinservmarkets.in/insurance/health-insurance/family-health-insurance.html?pid=Web-Platforms:SPA:4w-SPA-Reject:Family-Health-Insurance:Banner:CrossSell'
  };
  public static congratulationsBanner = {
    MutualUrl: 'https://www.bajajfinservmarkets.in/Investment/mutual-fund.html?pid=Web-Platforms:SPA:2w-SPA-PolicySuccess:MF-Investment:Banner:CrossSell',
    MutualUrl4W: 'https://www.bajajfinservmarkets.in/Investment/mutual-fund.html?pid=Web-Platforms:SPA:4w-SPA-PolicySuccess:MF-Investment:Banner:CrossSell',
    emistoreDUrl: 'https://www.bajajfinservmarkets.in/emi-store?utm_source=bfsd&utm_medium=journey&utm_campaign=mktplc_20190906_insurancejourneycomplete_01',
    EmistoreMUrl: 'https://www.bajajfinservmarkets.in/emi-store?utm_source=bfsd&utm_medium=journey&utm_campaign=mktplc_20190906_insurancejourneycomplete_02'
  };
  public static serviceErrors = ['APDM-201', 'APDM-202', 'APDM-203', 'APDM-204'];
  public static paCoverCode = {
    TWGI: '2W_FEATURE04',
    FWGI: '4W_FEATURE08',
    TXGI: '',
    CVGI: ''
  };
  public static ZeroDeptCode = {
    TWGI: '2W_FEATURE03',
    FWGI: '4W_FEATURE03',
    TXGI: '',
    CVGI: ''
  };
  public static PrincipleCodes = {
    HDFC: 'HDFCERGO',
    ICICI: 'ICICI',
    TAGIC : 'TAGIC'
  }
  public static ProdUrlString = {
    TwoWheeler: {
      pathname: 'insurance/two-wheeler-insurance/bike-insurance-premium-calculator'
    },
    FourWheeler: {
      pathname: 'insurance/car-insurance/car-insurance-premium-calculator'
    },
    Taxi: {
      pathname: 'insurance/commercial-vehicle-insurance/taxi-car-insurance-calculator'
    },
    Commercial: {
      pathname: 'insurance/commercial-vehicle-insurance/commercial-vehicle-insurance-calculator'
    }
  };

  public static ProdInsuranceUrlType = {
    TwoWheeler: {
      pathname: 'two-wheeler-insurance'
    },
    FourWheeler: {
      pathname: 'car-insurance'
    },
    Taxi: {
      pathname: 'taxi-car-insurance-calculator'
    },
    Commercial: {
      pathname: 'commercial-vehicle-insurance-calculator'
    }
  };
  public static platforms = {
    ios: 'ios',
    android: 'android'
  };
  public static validateOtpErrorCodes: any = [
    'QDM-516', 'QDM-518'
  ];
  public static vehicleType_errorMessages = ['apdm-248', 'apdm-249', 'apdm-250', 'pris-728', 'apdm-229','omib-0052'];
  public static BflEnvironmentNames = ['uat:bfl', 'ppd:bfl', 'prod:bfl'];

  public static SsoConstants = {
    'CIPHER_KEY': '5u8x/A%D*Gv9y$B&',
    'CUSTOMER_DEDUPE_API': '/v1/insurance/business/customerdedupe',
    'BusinessServiceLoginURL': '/v1/insurance/business/federatedlogin'
  }
  public static utmSource = {
    organic : 'Organic'
  }

  public static applicationCreationErrorCode = ['APDM-907'];
  public static PlanTypes = {
    'CP': 'Comprehensive Plans',
    'TP': 'Third Party Plans',
    'OD': 'Own Damage Plans',
    'RENEWAL': 'Renew your existing plan',
    'LCP': 'Long Term Comprehensive plan'
  }
  
  public static wrongVehicleNumberText = "It appears you have entered a wrong vehicle number, enter a two wheeler number to continue.";
  public static vehicleRegistrationPattern = {
    'pattern': /^[A-Z]{2}(?!00)[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$|^[A-Z]{2}[0-9]{6}$/,
    'bhSeriesPattern': /^(2[1-9]|[3-9][0-9])BH[0-9]{4}[A-Z]{1}$/
  }

  public static invalidPatternErrorMsg = "Enter the valid registration number & experience the one-click purchase process!";
  public static rtoCodeSmartSearchPlaceholderMsg = "PLEASE SELECT FROM THE LIST.";
  public static policyYearLessThanErrMsg = "The Policy expiry year should not be less than 2000";
  public static policyDateMoreThan60DaysErrMsg = "Your quotes cannot be fetched as your policy expiry is more than 60 days from now.";
  public static policyDateInvalidErrMsg = "Please provide correct Policy Expiry Date.";
  public static successText = "We've successfully received your payment!";
  public static bflHomePageUrl = 'https://www.bajajfinserv.in/insurance';


  // Label placeholder for full name field
  public static LABELPLACEHOLDERS = {
    labels : {
      customerName: "Enter Name as per PAN card",
      customerNoteInfo: "Will be used for communication",
    },
    placeholders: {
      customerName: "Enter Name as per PAN card",
    },
    errorMESG: {
        mandatoryField: 'This is a mandatory field.',
        customerNameErrMsg:  'Please provide Proposer name',
        lastNameErrMsg:  'Last name is mandatory.',
        firstNameAcceptTwoCharErrMsg: 'Please provide First name atleast two characters.'
    },
  }

  public static renewalPlans = ['ICICI', 'TAGIC', 'BAGIC'];

}


export enum VehicleTypeValues {
  FWGI = 'FWGI',
  TWGI = 'TWGI'
}
